(() => {
  if (customElements.get('alleycat-popup-flyer')) return;

  class AlleycatPopupFlyer extends HTMLElement {
    static get observedAttributes() {
      return ['data-parallax', 'data-parallax-mobile'];
    }

    connectedCallback() {
      this.motionQuery = matchMedia('(prefers-reduced-motion: no-preference)');
      this.mobileQuery = matchMedia('(max-width: 749px)');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.syncMotion = () => {
        this.stopMotion();
        if (!this.motionEnabled()) return;
        this.listeners = new AbortController();
        const { signal } = this.listeners;
        window.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal });
        window.addEventListener('pageshow', this.schedule, { signal });
        this.addEventListener('load', this.schedule, { capture: true, signal });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.schedule);
          this.resizeObserver.observe(this);
          const content = this.closest('.alleycat-popup-events__content');
          if (content) this.resizeObserver.observe(content);
        }
        this.schedule();
      };
      this.motionQuery.addEventListener('change', this.syncMotion);
      this.mobileQuery.addEventListener('change', this.syncMotion);
      this.syncMotion();
    }

    attributeChangedCallback() {
      if (this.isConnected && this.syncMotion) this.syncMotion();
    }

    motionEnabled() {
      return this.isConnected && this.dataset.parallax === 'true' && this.motionQuery.matches &&
        (!this.mobileQuery.matches || this.dataset.parallaxMobile === 'true');
    }

    update() {
      if (!this.motionEnabled()) return;
      // The stationary, padded wrapper reserves the complete travel distance.
      // Measuring it avoids transform feedback and scroll-driven layout changes.
      const { top, height } = this.getBoundingClientRect();
      const viewportHeight = document.documentElement.clientHeight;
      if (!height || !viewportHeight) return;
      const strength = parseFloat(getComputedStyle(this).getPropertyValue('--popup-parallax-room')) || 0;
      const progress = Math.max(0, Math.min(1, (viewportHeight - top) / (viewportHeight + height)));
      this.style.setProperty('--popup-flyer-lift', `${((progress * 2 - 1) * strength).toFixed(2)}px`);
    }

    stopMotion() {
      this.listeners?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.style.removeProperty('--popup-flyer-lift');
    }

    disconnectedCallback() {
      this.motionQuery?.removeEventListener('change', this.syncMotion);
      this.mobileQuery?.removeEventListener('change', this.syncMotion);
      this.stopMotion();
    }
  }

  customElements.define('alleycat-popup-flyer', AlleycatPopupFlyer);
})();
